import { render, staticRenderFns } from "./service-ride-general-info.vue?vue&type=template&id=708cf46c&scoped=true"
import script from "./service-ride-general-info.vue?vue&type=script&lang=js"
export * from "./service-ride-general-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cf46c",
  null
  
)

export default component.exports